import { render } from "./CampaignJobForm.vue?vue&type=template&id=628b9a9c"
import script from "./CampaignJobForm.vue?vue&type=script&lang=js"
export * from "./CampaignJobForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__